export default "__VITE_ASSET__DEOUeqAX__"